import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { AccountInstitutionContainer } from './AccountInstitutionContainer';

export const AccountInstitutionPicker = (props) => {
  const { resource } = props;
  // If the account resource has the linkedInstitution relationship we should show sync status, otherwise this is not a linked account
  return resource.withRelationship((fr.relationships.linkedInstitution.name),
    (_) => <AccountInstitutionContainer {...props} />,
    () => null);
};

AccountInstitutionPicker.defaultProps = {
};

AccountInstitutionPicker.propTypes = {
  resource: PropTypes.object.isRequired,
  onDeleteSuccess: PropTypes.func.isRequired,
  onActionSuccess: PropTypes.func.isRequired,
};
